import * as React from "react";
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader } from "@/components/ui/loader";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";
import { Item } from "@/types/fse";
import { BusinessReportSelectFileContentSearch, SearchFormInputs } from "./search";
import { BusinessReportSelectFileContentRow } from "./row";
import { useSearchQuery } from "@/api/files";

interface Props {
  businessReport: BusinessReport;
  setIsOpen: (isOpen: boolean) => void;
}

const emptyList: Item[] = [];

export const BusinessReportSelectFileContent: React.FC<Props> = ({ businessReport, setIsOpen }) => {
  const [query, setQuery] = React.useState("");
  const handleClose = () => {
    setIsOpen(false);
  };

  const onSearch = ({ query }: SearchFormInputs) => {
    setQuery(query);
  };

  const { data: items = emptyList, isLoading } = useSearchQuery({ query, entry_type: ["file", "folder"] });

  return (
    <DialogContent className="flex h-[80vh] max-h-[600px] w-full max-w-[90vw] flex-grow flex-col">
      <DialogHeader>
        <DialogTitle>Select file to SnapShot</DialogTitle>
      </DialogHeader>
      <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
        <BusinessReportSelectFileContentSearch onSearch={onSearch} />
        {!query && <p className="text-md text-center text-gray-500">Type file name to search and generate SnapShot.</p>}
        {isLoading && <Loader />}
        {query && !items.length && !isLoading && <p className="text-md text-center text-gray-500">No files found.</p>}
        {!!items.length && (
          <div className="flex flex-grow flex-col overflow-y-scroll">
            {items.map(item => (
              <BusinessReportSelectFileContentRow key={item.id} item={item} businessReport={businessReport} />
            ))}
          </div>
        )}
      </div>
      <div className="mt-4 flex justify-between">
        <Button variant="outline" onClick={handleClose}>
          Cancel
        </Button>
      </div>
    </DialogContent>
  );
};
